import { render, staticRenderFns } from "./EmployeeNotificationFrom.vue?vue&type=template&id=324c3c52"
import script from "./EmployeeNotificationFrom.vue?vue&type=script&lang=ts"
export * from "./EmployeeNotificationFrom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports